import { Component, TemplateFunction } from '@ribajs/core'

interface Scope {
  content: string
}

/**
 * Use this component to inject sections html into the dom.
 */
export class SbDynamicSectionsComponent extends Component {
  public static tagName = 'sb-dynamic-sections'

  public scope: Scope = {
    content: '',
  }

  static get observedAttributes(): string[] {
    return []
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbDynamicSectionsComponent.observedAttributes)
  }

  protected async afterBind() {
    await super.afterBind()
    this.classList.add(`${SbDynamicSectionsComponent.tagName}-ready`)
    this.debug('afterBind', this)
  }

  protected template(): ReturnType<TemplateFunction> {
    return `<div class="dynamic-sections-container" rv-template="content"></div>`
  }

  /**
   * Clears the content / sections of this component
   */
  public clear() {
    this.debug('[SbDynamicSectionsComponent] clear')
    this.scope.content = ''
  }

  public setSections(content: string) {
    this.debug('[SbDynamicSectionsComponent] setSections', content)
    this.scope.content = content
  }
}
